import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import ScanModal from "./ScanModal";

const SearchBar = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchTerm, setSearchTerm] = useState(searchParams.get("q") || "");
  const [isScanModalOpen, setIsScanModalOpen] = useState(false);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchTerm.trim()) {
      setSearchParams({ q: searchTerm });
      navigate(`/?q=${encodeURIComponent(searchTerm)}`);
    } else {
      setSearchParams({});
      navigate("/");
    }
  };

  return (
    <>
      <form onSubmit={handleSearch} className="flex flex-col md:flex-row gap-4 items-center justify-between">
        <div className="relative w-full md:w-96">
          <Input
            type="search"
            placeholder={t('products.searchPlaceholder')}
            className="w-full"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div className="flex gap-2 w-full md:w-auto">
          <Button type="submit" className="flex-1 md:flex-none">
            {t('products.search')}
          </Button>
          <Button 
            type="button" 
            onClick={() => setIsScanModalOpen(true)} 
            variant="outline" 
            className="flex-1 md:flex-none"
          >
            {t('products.scanProduct')}
          </Button>
        </div>
      </form>
      
      <ScanModal 
        open={isScanModalOpen}
        onOpenChange={setIsScanModalOpen}
      />
    </>
  );
};

export default SearchBar;